import { getQueryParam } from './utils';

const getMonthlyDuration = locationSearch => {
  const durationString = getQueryParam(locationSearch, 'monthly_duration');
  const duration = Number(durationString);

  if (!durationString) {
    return null;
  }

  return duration <= 12 ? String(duration) : '0';
};

export default getMonthlyDuration;
